(function () {
  var targetId = 'trustbadge-container-98e3dadd90eb493088abdc5597a70810';
  var desiredZIndex = '998';

  function fix() {
    var el = document.getElementById(targetId);
    if (el && el.style.zIndex !== desiredZIndex) {
      el.style.zIndex = desiredZIndex;
    }
  }

  var observer = new MutationObserver(fix);
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['style']
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fix);
  } else {
    fix();
  }
})();